import React from 'react';
import Navigation from '../components/Navigation';
import './CareersPage.css';

const CareersPage = () => {
  const roles = [
    {
      title: 'The Narrative Architect',
      focus: 'Hard Sci-Fi Literature & Philosophy',
      description: (
        <>
          This is a role for a <strong>World Builder</strong>. You will work directly with the Founder to architect an ambitious Hard Sci-Fi literary universe exploring the collision of 5th-dimensional physics, Dyson Spheres, and the evolution of consciousness.
          {'\n\n'}
          What you will build:
          {'\n\n'}
          <strong>The Literary Universe:</strong> Draft scenes that bridge the gap between <em>Interstellar</em> science and <em>Siddhartha</em> spirituality. You will write dialogue where characters debate the ethics of civilizational collapse and the mathematics of enlightenment.
          {'\n\n'}
          <strong>The Wisdom Scripts:</strong> Research and decode Vedic, Buddhist, and Shamanic scriptures to create the 'Soul' for our virtual AI archetypes. You will translate ancient metaphysics into accessible, modern narratives for a global audience.
          {'\n\n'}
          <strong>The Craft:</strong> We value intellectual tension over melodrama. You will structure non-linear timelines, refine character voices (from cynical AIs to ascetic monks), and ensure our lore is grounded in rigorous research.
        </>
      )
    },
    {
      title: 'The Creative Technologist',
      focus: 'Generative AI & App Design',
      description: (
        <>
          The <strong>'Digital Alchemist.'</strong> We are looking for a rare hybrid who possesses an Artist's Eye (Composition/Lighting) and an Engineer's Brain (Code/Logic). You will visualize abstract spiritual concepts using Generative AI and implement them into functional mobile prototypes.
          {'\n\n'}
          What you will build:
          {'\n\n'}
          <strong>High-Fidelity Art:</strong> Use <em>Midjourney</em>, <em>Flux</em>, and <em>ComfyUI</em> to create cinematic concept art—from futuristic Zen temples to 3D representations of Eastern mythology. You treat prompting like code, iterating on lighting and texture until the output is cinematic.
          {'\n\n'}
          <strong>App Implementation:</strong> Take these visual assets and implement them into our React Native app prototype. You aren't just making JPEGs; you are tweaking the UI code to ensure the 'Vibe' matches the vision.
          {'\n\n'}
          <strong>Motion:</strong> Transform static images into atmospheric video loops (using <em>Runway/Pika</em>) for our social media storytelling engine.
        </>
      )
    },
    {
      title: 'The Growth Hacker',
      focus: 'Publishing & Algorithms',
      description: (
        <>
          Treat book marketing as a <strong>science</strong>. You will manage the launch of our pilot title in the spiritual memoir genre, building the playbook for a future library of works.
          {'\n\n'}
          What you will build:
          {'\n\n'}
          <strong>The Engine:</strong> Audit and optimize Amazon KDP ads from the ground up. You will manage daily ad spend with a focus on <strong>ACOS</strong> (Advertising Cost of Sales) and profitability, not just vanity metrics.
          {'\n\n'}
          <strong>The Discovery:</strong> Identify and target niche audiences who sit at the intersection of 'Eastern Philosophy' and 'Tech Optimism.' You will A/B test blurbs, covers, and keywords to find the signal in the noise.
          {'\n\n'}
          <strong>The Strategy:</strong> This is not about blasting emails; it is about <em>precision</em>. You will analyze conversion data to refine our positioning and execute a roadmap for scaling from one book to a multi-title ecosystem.
        </>
      )
    }
  ];

  const handleEmailClick = (role) => {
    window.location.href = `mailto:jobs@tara-ventures.com?subject=Application: ${role}`;
  };

  return (
    <div className="careers-page">
      <Navigation />
      {/* Header Section */}
      <section className="careers-header section-padding">
        <div className="container">
          <div className="careers-header-content">
            <h1 className="careers-headline heading-1">
              The Winter & Spring Internship Cohort
            </h1>
            <p className="careers-subheadline hero-medium">
              We are looking for Polymaths. Builders. Outliers.
            </p>
            <div className="careers-body body-large">
              <p>
                Tara Ventures is recruiting for a selective off-cycle cohort (Immediate Start). 
                We are not looking for employees; we are looking for partners to build the next 
                generation of Deep Tech and Cultural Systems.
              </p>
              <div className="careers-offer">
                <h3 className="heading-3">The Offer:</h3>
                <ul className="offer-list">
                  <li><strong>Stipend:</strong> Competitive</li>
                  <li><strong>Location:</strong> Remote (Singapore HQ)</li>
                  <li><strong>Duration:</strong> Rolling / Flexible (1-3 Months)</li>
                  <li><strong>Focus:</strong> Hard Sci-Fi, Generative AI, and Digital Heritage</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Roles Grid Section */}
      <section className="careers-roles section-padding-small">
        <div className="container">
          <div className="roles-grid">
            {roles.map((role, index) => (
              <div key={index} className="role-card">
                <div className="role-card-inner">
                  <h3 className="heading-3 role-title">{role.title}</h3>
                  <p className="role-focus body-small">{role.focus}</p>
                  <div className="body-regular role-description">{role.description}</div>
                  <button 
                    className="btn-primary role-apply-btn"
                    onClick={() => handleEmailClick(role.title)}
                  >
                    Apply via Email
                  </button>
                </div>
                <div className="role-corner-accent"></div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Footer CTA Section */}
      <section className="careers-cta section-padding-small">
        <div className="container">
          <div className="cta-content">
            <p className="body-large cta-text">
              To apply, send your CV and Portfolio directly to our team. 
              Please include the specific role in your subject line.
            </p>
            <button 
              className="btn-primary cta-button"
              onClick={() => window.location.href = 'mailto:jobs@tara-ventures.com'}
            >
              Email Application
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CareersPage;
